// === src/components/Bxinventar/Create.jsx ===
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Alert,
  Button,
  ButtonGroup,
  Badge,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../axiosConfig";
import { BxinventarForm, useEmptyBxinventar } from "./Form";

// normalize pt dirty-detect stabil (ca intrare) :contentReference[oaicite:1]{index=1}
function normalizeBxinventar(m) {
  if (!m) return null;
  const { id, created_at, updated_at, user_id, linii = [], ...rest } = m;

  const normLinii = [...linii]
    .map(({ id, created_at, updated_at, _tmp, ...ln }) => ln)
    .sort((a, b) => {
      const ka = a.bxidlns ?? a.bxpart_id ?? 0;
      const kb = b.bxidlns ?? b.bxpart_id ?? 0;
      return ka === kb ? 0 : ka < kb ? -1 : 1;
    });

  return { ...rest, linii: normLinii };
}
const hash = (obj) => JSON.stringify(obj);

export default function BxinventarCreate() {
  const navigate = useNavigate();
  const empty = useEmptyBxinventar();

  const [form, setForm] = useState(empty);
  const [initialForm, setInitialForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const originalHash = useMemo(
    () => hash(normalizeBxinventar(initialForm)),
    [initialForm],
  );
  const currentHash = useMemo(() => hash(normalizeBxinventar(form)), [form]);
  const isDirty = originalHash !== currentHash;

  const statusText = isDirty ? "Modificat (nesalvat)" : "Completare";
  const statusVariant = isDirty ? "warning" : "info";

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isDirty]);

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post(`/bxinventar`, form);
      toast.success("Inventarul a fost creat cu succes!");
      navigate(`/bxinventar/${data.id}/edit`);
    } catch (e) {
      setError(String(e.message || e));
      toast.error(`Eroare la salvare: ${e.message || e}`);
    } finally {
      setSaving(false);
    }
  };

  const saveAndNew = async () => {
    setSaving(true);
    setError("");
    try {
await api.post(`/bxinventar`, form);
      toast.success("Inventarul a fost creat cu succes!");
      const fresh = { ...empty, bxdoc_date: new Date().toISOString() };
      setForm(fresh);
      setInitialForm(fresh);
    } catch (e) {
      setError(String(e.message || e));
      toast.error(`Eroare la salvare: ${e.message || e}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          <h3 className="mb-0">Creează inventar</h3>
          <Badge bg={statusVariant}>{statusText}</Badge>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="primary"
            disabled={!isDirty || saving}
            onClick={save}
          >
            {saving && <Spinner size="sm" className="me-2" />}Salvează
          </Button>
        </div>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <BxinventarForm
        value={form}
        onChange={setForm}
        onSubmit={save}
        submitting={saving}
      />

      <div className="d-flex justify-content-end mt-3">
        <ButtonGroup>
          <Button
            variant="primary"
            disabled={!isDirty || saving}
            onClick={save}
          >
            {saving && <Spinner size="sm" className="me-2" />}Salvează
          </Button>
          <Button
            variant="outline-secondary"
            disabled={!isDirty || saving}
            onClick={saveAndNew}
          >
            Salvează și creează altul
          </Button>
        </ButtonGroup>
      </div>
    </Container>
  );
}
